import Place from "@client/layout/Place/container";
import { type WithChildrenIds, type WithEntitiesSource } from "@client/types";
import * as React from "react";
import Entity from "../Entity/container";

export default (props: WithChildrenIds & WithEntitiesSource) => (
  <Place>
    {props.childrenIds.map((id) => (
      <Entity key={id} id={id} source={props.source} viewonly />
    ))}
  </Place>
);
